import axios from 'axios';

export const serialize = (obj) => {
  const str = [];
  Object.keys(obj).forEach(p => {
    str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
  });
  return str.join('&');
};

export const replaceStringWithParams = (str, obj) => {
  Object.keys(obj).forEach(j => {
    const regExp = new RegExp(j, 'g');
    str = str.replace(regExp, obj[j]);
  });
  return str;
};

export function AxiosService(obj) {
  const _that = this;

  (function __construct(obj) {
    _that.headers = obj.headers;
    _that.params = obj.params || {};
    _that.method = obj.method.toLowerCase();
    _that.url = obj.url;
    _that.isSerialize = obj.isSerialize || null;
  }(obj));

  this.setHeaders = setHeaders;
  this.setParams = setParams;
  this.get = handleGet;
  this.post = handlePost;
  this.all = handleAll;
  this.doAjax = doAjax;
  this.doAjaxPost = doAjaxPost;

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  if(!window.axios_source){
    window.axios_source = [];
  }
  window.axios_source.push(source);

  function doAjax() {
    try {
      delete _that.params.catalog_tag_filter;
    } catch (e) {
      console.log('tatasky_B2BPortal api service');
    }


    const data = _that.params;
    const convertParamsToUpdateUrl = {};
    Object.keys(data).forEach(i => {
      convertParamsToUpdateUrl[`{${i}}`] = data[i];
    });
    let url = replaceStringWithParams(_that.url, convertParamsToUpdateUrl);
    /*
         * No Serialization required here, I have handled it in interceptor, please look src/app.js
         * Serialization will be handled based on request headers if request Header is
         * Content-Type == GlobalConfig.getHeaders(['URL_ENCODED'])['Content-Type'];
         * then only request will be serialized otherwise json will be send to server.
         * */
    if (_that.method === 'get') {
      if (_that.params && Object.keys(_that.params).length > 0) {
        url += `?${serialize(_that.params)}`;
      }
    } 

    return axios({
      method: _that.method,
      url,
      headers: Object.assign({}, _that.headers), // weired cannot directly pass _that.headers as it doesn't reflect, need to figure it out later.
      data,
      cancelToken: source.token,
    });

  }

  function doAjaxPost(responseType){
    return axios({
      method: _that.method,
      url : _that.url,
      responseType:responseType,
      headers: Object.assign({}, _that.headers), // weired cannot directly pass _that.headers as it doesn't reflect, need to figure it out later.
      data: _that.params,
      cancelToken: source.token,
    });
  }

  function setParams(obj) {
    if (obj) {
      Object.keys(obj).forEach(i => {
        this.params[i] = obj[i];
      });
    }
  }

  function setHeaders(key, val) {
    this.headers[key] = val;
  }

  function handleGet() {
    this.doAjax('get');
  }

  function handlePost() {
    this.doAjax('post');
  }

  function handleAll(promises) { // promises will be promise objects array e.g. [axios.get('/user'), axios.get('/comments')]
    return axios.all(promises);
  }
}

